// import React, { useState, ChangeEvent, FormEvent } from 'react';
// import { ToastContainer, toast } from 'react-toastify';
// import {
// 	TextField,
// 	Button,
// 	Box,
// 	InputLabel,
// 	MenuItem,
// 	Select,
// 	SelectChangeEvent,
// 	FormControl,
// 	FormHelperText,
// 	Dialog,
// 	DialogTitle,
// 	IconButton,
// 	DialogContent,
// } from '@mui/material';
// import Grid from '@mui/material/Grid';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import CloseIcon from '@mui/icons-material/Close';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs, { Dayjs } from 'dayjs';
// import validate from '../../../../components/component/resused-component/Validation2'; // Import the validation component
// import { createQuotation } from '../../../../services/api/QuoationAPI';

// interface FormData {
// 	name: string;
// 	email: string;
// 	mobile: string;
// 	eventType: string;
// 	noOfPeople: string;
// 	address: string;
// 	area: string;
// 	functionDate: Dayjs | null;
// }

// interface Errors {
// 	name?: string;
// 	email?: string;
// 	mobile?: string;
// 	eventType?: string;
// 	noOfPeople?: string;
// 	address?: string;
// 	area?: string;
// 	functionDate?: string;
// }

// interface QuotationForm {
// 	open: boolean;
// 	handleClose: () => void;
// 	defaultMenuId: string;
// 	eventID: string;
// }

// const GetQuotationForm: React.FC<QuotationForm> = ({
// 	open,
// 	handleClose,
// 	defaultMenuId,
// 	eventID,
// }) => {
// 	const [formData, setFormData] = useState<FormData>({
// 		name: '',
// 		email: '',
// 		mobile: '',
// 		eventType: '',
// 		noOfPeople: '',
// 		address: '',
// 		area: '',
// 		functionDate: null,
// 	});
// 	const [loadingData, setLoadingData] = useState(false);
// 	const [errors, setErrors] = useState<Errors>({});

// 	const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
// 		const { name, value } = e.target;
// 		setFormData({
// 			...formData,
// 			[name]: value,
// 		});

// 		const fieldErrors = validate({ ...formData, [name]: value });
// 		if (!fieldErrors[name as keyof FormData]) {
// 			setErrors((prevErrors) => ({
// 				...prevErrors,
// 				[name]: undefined,
// 			}));
// 		}
// 	};

// 	const handleSelectChange = (e: SelectChangeEvent<string>) => {
// 		const { name, value } = e.target;
// 		setFormData({
// 			...formData,
// 			[name]: value,
// 		});

// 		const fieldErrors = validate({ ...formData, [name]: value });
// 		if (!fieldErrors[name as keyof FormData]) {
// 			setErrors((prevErrors) => ({
// 				...prevErrors,
// 				[name]: undefined,
// 			}));
// 		}
// 	};

// 	const handleSubmit = async (e: FormEvent) => {
// 		e.preventDefault();
// 		const validationErrors = validate(formData);
// 		if (Object.keys(validationErrors).length === 0) {
// 			try {
// 				setLoadingData(true);
// 				// Construct the payload
// 				const submissionData = {
// 					// ...formData,
// 					name: formData.name,
// 					email: formData.email,
// 					mobile: formData.mobile,
// 					functionDate: formData.functionDate,
// 					defaultMenuId,
// 					eventType: eventID,
// 					location: `${formData.address}, ${formData.area}`,
// 					isDefaultMenu: true,
// 				};

// 				console.log('Form data submitted:', submissionData);

// 				const response = await createQuotation(submissionData);

// 				if (response.success) {
// 					toast.success(response?.data?.message);
// 					setFormData({
// 						name: '',
// 						email: '',
// 						mobile: '',
// 						eventType: '',
// 						noOfPeople: '',
// 						address: '',
// 						area: '',
// 						functionDate: null,
// 					});
// 					handleClose();
// 				}
// 			} catch (error) {
// 				console.error('Error submitting form:', error);
// 			} finally {
// 				setLoadingData(false);
// 			}
// 		} else {
// 			setErrors(validationErrors);
// 		}
// 	};

// 	return (
// 		<Box>
// 			<Dialog
// 				open={open}
// 				// onClose={handleClose}
// 				fullWidth
// 				maxWidth="sm"
// 				slotProps={{
// 					backdrop: {
// 						sx: {
// 							backgroundColor: 'rgba(0, 0, 0, 0.74)', // custom backdrop color + opacity
// 						},
// 					},
// 				}}
// 			>
// 				<DialogTitle fontWeight={500} fontSize={'20px'}>
// 					Get Quotation
// 					<IconButton
// 						aria-label="close"
// 						onClick={handleClose}
// 						sx={{ position: 'absolute', right: 8, top: 8 }}
// 					>
// 						<CloseIcon />
// 					</IconButton>
// 				</DialogTitle>
// 				<DialogContent dividers>
// 					<LocalizationProvider dateAdapter={AdapterDayjs}>
// 						<Box
// 							component="form"
// 							onSubmit={handleSubmit}
// 							noValidate
// 							sx={{
// 								width: '100%',
// 								p: 2,
// 							}}
// 						>
// 							<Grid container spacing={2} justifyContent="center" alignItems="center">
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<TextField
// 										color="secondary"
// 										fullWidth
// 										label="Name"
// 										name="name"
// 										value={formData.name}
// 										onChange={handleTextFieldChange}
// 										error={!!errors.name}
// 										helperText={errors.name}
// 										size="small"
// 									/>
// 								</Grid>
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<TextField
// 										color="secondary"
// 										fullWidth
// 										label="Enter Your Email"
// 										name="email"
// 										value={formData.email}
// 										onChange={handleTextFieldChange}
// 										error={!!errors.email}
// 										helperText={errors.email}
// 										size="small"
// 									/>
// 								</Grid>
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<TextField
// 										color="secondary"
// 										fullWidth
// 										label="Enter Contact No."
// 										name="mobile"
// 										value={formData.mobile}
// 										onChange={handleTextFieldChange}
// 										error={!!errors.mobile}
// 										helperText={errors.mobile}
// 										size="small"
// 										slotProps={{
// 											input: {
// 												inputProps: {
// 													inputMode: 'numeric',
// 													pattern: '[0-9]*',
// 												},
// 											},
// 										}}
// 									/>
// 								</Grid>
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<FormControl
// 										fullWidth
// 										error={!!errors.eventType}
// 										size="small"
// 										color="secondary"
// 									>
// 										<InputLabel id="demo-simple-select-label">
// 											Quick Menu
// 										</InputLabel>
// 										<Select
// 											color="secondary"
// 											name="eventType"
// 											labelId="demo-simple-select-label"
// 											id="demo-simple-select"
// 											value={formData.eventType}
// 											onChange={handleSelectChange}
// 											label="Quick Menu"
// 											disabled
// 										>
// 											<MenuItem value="" disabled>
// 												Quick Menu
// 											</MenuItem>
// 											<MenuItem value="wedding">Wedding</MenuItem>
// 											<MenuItem value="birthday">Birthday</MenuItem>
// 											<MenuItem value="corporate">Corporate</MenuItem>
// 											<MenuItem value="customized">Customizable</MenuItem>
// 										</Select>
// 										{errors.eventType && (
// 											<FormHelperText>{errors.eventType}</FormHelperText>
// 										)}
// 									</FormControl>
// 								</Grid>
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<DatePicker
// 										label="Select Date"
// 										value={formData.functionDate}
// 										minDate={dayjs().add(1, 'day')}
// 										onChange={(newValue: Dayjs | null) => {
// 											setFormData((prevFormData) => ({
// 												...prevFormData,
// 												functionDate: newValue,
// 											}));
// 											const fieldErrors = validate({
// 												...formData,
// 												functionDate: newValue,
// 											});
// 											if (!fieldErrors.functionDate) {
// 												setErrors((prevErrors) => ({
// 													...prevErrors,
// 													functionDate: undefined,
// 												}));
// 											}
// 										}}
// 										slotProps={{
// 											textField: {
// 												fullWidth: true,
// 												error: !!errors.functionDate,
// 												helperText: errors.functionDate,
// 												size: 'small',
// 											},
// 										}}
// 									/>
// 								</Grid>
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<TextField
// 										color="secondary"
// 										fullWidth
// 										label="No of People"
// 										name="noOfPeople"
// 										value={formData.noOfPeople}
// 										onChange={(e) => {
// 											const value = e.target.value;
// 											if (/^\d*$/.test(value)) {
// 												const sanitizedValue = value.replace(/^0+/, '');
// 												setFormData({
// 													...formData,
// 													noOfPeople: sanitizedValue,
// 												});
// 												const fieldErrors = validate({
// 													...formData,
// 													noOfPeople: sanitizedValue,
// 												});
// 												if (!fieldErrors.noOfPeople) {
// 													setErrors((prevErrors) => ({
// 														...prevErrors,
// 														noOfPeople: undefined,
// 													}));
// 												}
// 											}
// 										}}
// 										error={!!errors.noOfPeople}
// 										helperText={errors.noOfPeople}
// 										size="small"
// 									/>
// 								</Grid>
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<TextField
// 										color="secondary"
// 										fullWidth
// 										label="Address"
// 										name="address"
// 										value={formData.address}
// 										onChange={handleTextFieldChange}
// 										error={!!errors.address}
// 										helperText={errors.address}
// 										size="small"
// 									/>
// 								</Grid>
// 								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
// 									<TextField
// 										color="secondary"
// 										fullWidth
// 										label="Pincode"
// 										name="area"
// 										value={formData.area}
// 										onChange={handleTextFieldChange}
// 										error={!!errors.area}
// 										helperText={errors.area}
// 										size="small"
// 									/>
// 								</Grid>
// 								<Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
// 									<Button
// 										type="submit"
// 										variant="contained"
// 										color="primary"
// 										sx={{ width: '80%' }}
// 										loading={loadingData}
// 										loadingIndicator="Submiting..."
// 									>
// 										Submit
// 									</Button>
// 								</Grid>
// 							</Grid>
// 						</Box>
// 					</LocalizationProvider>
// 				</DialogContent>
// 			</Dialog>
// 			<ToastContainer />
// 		</Box>
// 	);
// };

// export default GetQuotationForm;
// ====================================================================================================================
// ====================================================================================================================
// ====================================================================================================================
// ====================================================================================================================
// ====================================================================================================================
// ====================================================================================================================
// ====================================================================================================================
import React, { useState, ChangeEvent, FormEvent } from 'react';
import { ToastContainer } from 'react-toastify';
import {
	TextField,
	Button,
	Box,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	FormControl,
	FormHelperText,
	Dialog,
	DialogTitle,
	IconButton,
	DialogContent,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import Swal from 'sweetalert2';
import validate from '../../../../components/component/resused-component/Validation2'; // Import the validation component
import { createQuotation } from '../../../../services/api/QuoationAPI';

interface FormData {
	name: string;
	email: string;
	mobile: string;
	eventType: string;
	noOfPeople: string;
	address: string;
	area: string;
	functionDate: Dayjs | null;
}

interface Errors {
	name?: string;
	email?: string;
	mobile?: string;
	eventType?: string;
	noOfPeople?: string;
	address?: string;
	area?: string;
	functionDate?: string;
}

interface QuotationForm {
	open: boolean;
	handleClose: () => void;
	defaultMenuId: string;
	eventID: string;
}

const GetQuotationForm: React.FC<QuotationForm> = ({
	open,
	handleClose,
	defaultMenuId,
	eventID,
}) => {
	const [formData, setFormData] = useState<FormData>({
		name: '',
		email: '',
		mobile: '',
		eventType: '',
		noOfPeople: '1000',
		address: '',
		area: '',
		functionDate: null,
	});
	const [loadingData, setLoadingData] = useState(false);
	const [errors, setErrors] = useState<Errors>({});

	const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});

		const fieldErrors = validate({ ...formData, [name]: value });
		if (!fieldErrors[name as keyof FormData]) {
			setErrors((prevErrors) => ({
				...prevErrors,
				[name]: undefined,
			}));
		}
	};

	const handleSelectChange = (e: SelectChangeEvent<string>) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});

		const fieldErrors = validate({ ...formData, [name]: value });
		if (!fieldErrors[name as keyof FormData]) {
			setErrors((prevErrors) => ({
				...prevErrors,
				[name]: undefined,
			}));
		}
	};

	const handleSubmit = async (e: FormEvent) => {
		e.preventDefault();
		const validationErrors = validate(formData);
		if (Object.keys(validationErrors).length === 0) {
			try {
				setLoadingData(true);
				// Construct the payload
				const submissionData = {
					// ...formData,
					name: formData.name,
					email: formData.email,
					mobile: formData.mobile,
					functionDate: formData.functionDate,
					defaultMenuId,
					eventType: eventID,
					location: `${formData.address}, ${formData.area}`,
					isDefaultMenu: true,
				};

				console.log('Form data submitted:', submissionData);

				const response = await createQuotation(submissionData);

				if (response.success) {
					// toast.success(response?.data?.message);
					Swal.fire({
						icon: 'success',
						title: 'Thank you!',
						text: `${response?.data?.message}`,
						showConfirmButton: true,
						customClass: {
							popup: 'poppins-font',
						},
						backdrop: `rgba(0,0,0,0.4) left top no-repeat`,
						background: '#fff',
					});
					setFormData({
						name: '',
						email: '',
						mobile: '',
						eventType: '',
						noOfPeople: '',
						address: '',
						area: '',
						functionDate: null,
					});
					handleClose();
				}
			} catch (error) {
				console.error('Error submitting form:', error);
			} finally {
				setLoadingData(false);
			}
		} else {
			setErrors(validationErrors);
		}
	};

	return (
		<Box>
			<Dialog
				open={open}
				// onClose={handleClose}
				fullWidth
				maxWidth="sm"
				slotProps={{
					backdrop: {
						sx: {
							backgroundColor: 'rgba(0, 0, 0, 0.74)', // custom backdrop color + opacity
						},
					},
				}}
			>
				<DialogTitle fontWeight={500} fontSize={'20px'}>
					Get Quotation
					<IconButton
						aria-label="close"
						onClick={handleClose}
						sx={{ position: 'absolute', right: 8, top: 8 }}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<Box
							component="form"
							onSubmit={handleSubmit}
							noValidate
							sx={{
								width: '100%',
								p: 2,
							}}
						>
							<Grid container spacing={2} justifyContent="center" alignItems="center">
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									<TextField
										color="secondary"
										fullWidth
										label="Name"
										name="name"
										value={formData.name}
										onChange={handleTextFieldChange}
										error={!!errors.name}
										helperText={errors.name}
										size="small"
										variant="outlined"

										// slotProps={{
										// 	input: {
										// 		sx: {
										// 			fontSize: '14px',
										// 		},
										// 	},
										// }}
									/>
								</Grid>
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									<TextField
										color="secondary"
										fullWidth
										label="Email"
										name="email"
										value={formData.email}
										onChange={handleTextFieldChange}
										error={!!errors.email}
										helperText={errors.email}
										size="small"
										variant="outlined"
										// slotProps={{
										// 	input: {
										// 		sx: {
										// 			fontSize: '14px',
										// 		},
										// 	},
										// }}
									/>
								</Grid>
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									{/* <TextField
										color="secondary"
										fullWidth
										label="Enter Contact No."
										name="mobile"
										value={formData.mobile}
										onChange={handleTextFieldChange}
										error={!!errors.mobile}
										helperText={errors.mobile}
										size="small"
										slotProps={{
											input: {
												inputProps: {
													inputMode: 'numeric',
													pattern: '[0-9]*',
												},
												sx: {
													fontSize: '14px',
												},
											},
										}}
									/> */}
									<TextField
										color="secondary"
										fullWidth
										label="Mobile"
										name="mobile"
										value={formData.mobile}
										error={!!errors.mobile}
										helperText={errors.mobile}
										size="small"
										onChange={(e) => {
											const value = e.target.value;
											if (/^\d*$/.test(value)) {
												const sanitizedValue = value.replace(/^0+/, ''); // Remove leading zeros

												setFormData((prev) => ({
													...prev,
													mobile: sanitizedValue,
												}));

												const fieldErrors = validate({
													...formData,
													mobile: sanitizedValue,
												});

												if (!fieldErrors.mobile) {
													setErrors((prevErrors) => ({
														...prevErrors,
														mobile: undefined,
													}));
												}
											}
										}}
										variant="outlined"
										slotProps={{
											// input: {
											// 	sx: {
											// 		fontSize: '14px',
											// 	},
											// },
											htmlInput: {
												inputMode: 'numeric',
												pattern: '[0-9]*',
												maxLength: 10, // optional: limit to 10 digits
											},
										}}
									/>
								</Grid>
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									<FormControl
										fullWidth
										error={!!errors.eventType}
										size="small"
										color="secondary"
									>
										<InputLabel id="demo-simple-select-label">
											Quick Menu
										</InputLabel>
										<Select
											color="secondary"
											name="eventType"
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={formData.eventType}
											onChange={handleSelectChange}
											label="Quick Menu"
											disabled
											variant="outlined"
											// slotProps={{
											// 	input: {
											// 		sx: {
											// 			fontSize: '14px', // <-- input text size
											// 		},
											// 	},
											// }}
										>
											<MenuItem value="" disabled>
												Quick Menu
											</MenuItem>
											<MenuItem value="wedding">Wedding</MenuItem>
											<MenuItem value="birthday">Birthday</MenuItem>
											<MenuItem value="corporate">Corporate</MenuItem>
											<MenuItem value="customized">Customizable</MenuItem>
										</Select>
										{errors.eventType && (
											<FormHelperText>{errors.eventType}</FormHelperText>
										)}
									</FormControl>
								</Grid>
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									<DatePicker
										label="Select Date"
										value={formData.functionDate}
										minDate={dayjs().add(1, 'day')}
										onChange={(newValue: Dayjs | null) => {
											setFormData((prevFormData) => ({
												...prevFormData,
												functionDate: newValue,
											}));
											const fieldErrors = validate({
												...formData,
												functionDate: newValue,
											});
											if (!fieldErrors.functionDate) {
												setErrors((prevErrors) => ({
													...prevErrors,
													functionDate: undefined,
												}));
											}
										}}
										// slotProps={{
										// 	textField: {
										// 		fullWidth: true,
										// 		error: !!errors.functionDate,
										// 		helperText: errors.functionDate,
										// 		size: 'small',
										// 	},
										// }}
										slotProps={{
											textField: {
												fullWidth: true,
												error: !!errors.functionDate,
												helperText: errors.functionDate,
												size: 'small',
												sx: {
													'& .MuiInputBase-input': {
														fontSize: '14px', // input field text
													},
												},
											},
											popper: {
												placement: 'auto-start',
											},
										}}
									/>
								</Grid>
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									{/* <TextField
										color="secondary"
										fullWidth
										label="No of People"
										name="noOfPeople"
										value={formData.noOfPeople}
										onChange={(e) => {
											const value = e.target.value;
											if (/^\d*$/.test(value)) {
												const sanitizedValue = value.replace(/^0+/, '');
												setFormData({
													...formData,
													noOfPeople: sanitizedValue,
												});
												const fieldErrors = validate({
													...formData,
													noOfPeople: sanitizedValue,
												});
												if (!fieldErrors.noOfPeople) {
													setErrors((prevErrors) => ({
														...prevErrors,
														noOfPeople: undefined,
													}));
												}
											}
										}}
										error={!!errors.noOfPeople}
										helperText={errors.noOfPeople}
										size="small"
										slotProps={{
											input: {
												sx: {
													fontSize: '14px',
												},
											},
										}}
									/> */}
									<TextField
										color="secondary"
										fullWidth
										type="number"
										label="No of People"
										name="noOfPeople"
										value={formData.noOfPeople}
										onChange={(e) => {
											const value = e.target.value;
											if (/^\d*$/.test(value)) {
												setFormData({
													...formData,
													noOfPeople: value,
												});
											}
										}}
										onBlur={() => {
											const numericValue = Number(formData.noOfPeople);
											if (formData.noOfPeople !== '' && numericValue < 250) {
												setFormData({
													...formData,
													noOfPeople: '500',
												});
											}
										}}
										error={!!errors.noOfPeople}
										helperText={errors.noOfPeople}
										size="small"
										variant="outlined"
										// slotProps={{
										// 	input: {
										// 		sx: {
										// 			fontSize: '14px',
										// 		},
										// 	},
										// }}
									/>
								</Grid>
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									<TextField
										color="secondary"
										fullWidth
										label="Mandapam Name"
										name="address"
										value={formData.address}
										onChange={handleTextFieldChange}
										error={!!errors.address}
										helperText={errors.address}
										size="small"
										variant="outlined"
										// slotProps={{
										// 	input: {
										// 		sx: {
										// 			fontSize: '14px',
										// 		},
										// 	},
										// }}
									/>
								</Grid>
								<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
									<TextField
										color="secondary"
										fullWidth
										label="Area"
										name="area"
										value={formData.area}
										onChange={handleTextFieldChange}
										error={!!errors.area}
										helperText={errors.area}
										size="small"
										variant="outlined"
										placeholder="e.g. Avadi"
									/>
									{/* <TextField
										color="secondary"
										fullWidth
										label="Pincode"
										name="area"
										value={formData.area}
										onChange={(e) => {
											const value = e.target.value;
											if (/^\d*$/.test(value)) {
												// Only allow digits
												let sanitizedValue = value.replace(/^0+/, ''); // Remove leading zeros
												if (sanitizedValue.length > 6) {
													sanitizedValue = sanitizedValue.slice(0, 6); // Limit to 6 digits
												}

												setFormData((prev) => ({
													...prev,
													area: sanitizedValue,
												}));

												const fieldErrors = validate({
													...formData,
													area: sanitizedValue,
												});

												if (!fieldErrors.area) {
													setErrors((prevErrors) => ({
														...prevErrors,
														area: undefined,
													}));
												}
											}
										}}
										error={!!errors.area}
										helperText={errors.area}
										size="small"
										// inputProps={{
										// 	maxLength: 6,
										// 	inputMode: 'numeric',
										// 	pattern: '[0-9]*',
										// }}
										slotProps={{
											input: {
												sx: {
													fontSize: '14px',
												},
											},
											htmlInput: {
												maxLength: 6,
												inputMode: 'numeric',
												pattern: '[0-9]*',
											},
										}}
									/> */}
								</Grid>
								<Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
									<Button
										type="submit"
										variant="contained"
										color="primary"
										sx={{ width: '80%' }}
										loading={loadingData}
										loadingIndicator="Submiting..."
									>
										Submit
									</Button>
								</Grid>
							</Grid>
						</Box>
					</LocalizationProvider>
				</DialogContent>
			</Dialog>
			<ToastContainer />
		</Box>
	);
};

export default GetQuotationForm;
